import { styled, keyframes } from 'styled-components';
import { colors } from '../../abstracts';
export const skeletonKeyframes = keyframes(["0%{background-position:-200px 0;}100%{background-position:calc(200px + 100%) 0;}"]);
export const DefaultWrapper = styled.div.withConfig({
  displayName: "DefaultWrapper",
  componentId: "asurion-ui-react__sc-1ywvm3m-0"
})(["display:flex;flex-direction:column;gap:0.5rem;"]);
export const SkeletonElement = styled.div.withConfig({
  displayName: "SkeletonElement",
  componentId: "asurion-ui-react__sc-1ywvm3m-1"
})(["height:", ";width:", ";background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );background-size:200px 100%;background-repeat:no-repeat;border-radius:", ";animation:", " ", "ms ease-in-out infinite;"], ({
  $height
}) => $height, ({
  $width,
  $height,
  $circle
}) => $circle ? $height : $width, colors.neutralBrightest, colors.neutralBrightest, colors.neutralBrighter, colors.neutralBrightest, ({
  $circle
}) => $circle ? '50%' : '8px', skeletonKeyframes, ({
  $duration
}) => $duration);